module.exports = __webpack_public_path__ + "assets/img/gene2.588799b9.png";